module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__estado.7bae3f2f.svg";